const BACKEND_ORIGIN = (process.env.REACT_APP_API_URL || "").replace("/api/v1", "");

/**
 * Resolves a product image URL.
 * Local uploads are stored as `/static/...` relative paths — prefix them with
 * the backend origin so the browser fetches from the correct server.
 * GCS / external URLs are returned unchanged.
 */
export function resolveImageUrl(url: string | undefined | null, fallback = ""): string {
  if (!url) return fallback;
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) {
    return url;
  }
  return `${BACKEND_ORIGIN}${url}`;
}
